import React, { useEffect } from "react";
import { ReactFlowProvider } from "reactflow";
import "../../components/Loader/Loader.scss";
import "./querybuilder.css"

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setSemanticModelName,
  setSemanticSecretKey,
} from "../../service/apiSlices/staticApi";
import SemanticFlowWrapper from "./SemanticFlowWrapper";
import QueryBuilderProvider from "../../context/QueryBuilder/QueryBuilderProvider";

const SemanticModel = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {

    return () => {
      dispatch(setSemanticModelName(""));
      dispatch(setSemanticSecretKey(""));
      sessionStorage.removeItem("SemanticData");
    };
  }, [dispatch, navigate]);

  //   if (isChecking) return null;

  return (
    <QueryBuilderProvider>
      <ReactFlowProvider>
        <SemanticFlowWrapper />
      </ReactFlowProvider>
    </QueryBuilderProvider>
  );
};

export default SemanticModel;
